import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { useEffect, useState } from 'react';

import { LoadingSpinner } from '~components/Order/ordersDispatchStyledComponents';
import { useOmniReports } from '~hooks/useOmniReports/useOmniReports';

interface EmbeddedReportProps {
  companyId: string;
  reportId: string;
}

export const EmbeddedReport = ({ companyId, reportId }: EmbeddedReportProps) => {
  const [iframeUrl, setIframeUrl] = useState<string>('');
  const [iframeLoading, setIframeLoading] = useState<boolean>(false);

  const { isLoadingReport, getCompanyOmniReportById } = useOmniReports();

  // If the iframeUrl changes, set iframeLoading to true since we are loading a new report
  useEffect(() => {
    if (iframeUrl) {
      setIframeLoading(true);
    }
  }, [iframeUrl]);

  const isLoading = isLoadingReport || iframeLoading;

  const handleReportClick = async (id: string) => {
    const url = await getCompanyOmniReportById(companyId, id);
    setIframeUrl(url);
  };

  useEffect(() => {
    if (reportId) {
      handleReportClick(reportId);
    } else {
      setIframeUrl('');
    }
  }, [reportId]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        position: 'relative',
      }}
    >
      {isLoading && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flex: 1,
          }}
        >
          <LoadingSpinner isVisible />
        </Box>
      )}
      {iframeUrl ? (
        <iframe
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            position: 'absolute',
          }}
          title={'Omni Report'}
          src={iframeUrl}
          data-test-id="report-iframe"
          onLoad={() => setIframeLoading(false)}
          hidden={isLoading}
        />
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flex: 1,
          }}
        >
          <Typography>{t('omni.no_reports')}</Typography>
        </Box>
      )}
    </Box>
  );
};
